// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TwoFactorRouteImport } from './routes/two-factor'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignOutRouteImport } from './routes/sign-out'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RecoverAccountRouteImport } from './routes/recover-account'
import { Route as OrganizationRouteImport } from './routes/organization'
import { Route as MagicLinkRouteImport } from './routes/magic-link'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as EmailOtpRouteImport } from './routes/email-otp'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AppOnboardingRouteImport } from './routes/app/onboarding'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as OrganizationIndexRouteImport } from './routes/organization.index'
import { Route as OrganizationSettingsRouteImport } from './routes/organization.settings'
import { Route as OrganizationSplatRouteImport } from './routes/organization.$'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as AccountSettingsRouteImport } from './routes/account.settings'
import { Route as AccountSplatRouteImport } from './routes/account.$'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminPermissionsRouteImport } from './routes/admin/permissions'
import { Route as AdminOrganizationsRouteImport } from './routes/admin/organizations'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppTenantIdIndexRouteImport } from './routes/_app/$tenantId/index'
import { Route as AppTenantIdSettingsRouteImport } from './routes/_app/$tenantId/settings'
import { Route as AppTenantIdNumbersRouteImport } from './routes/_app/$tenantId/numbers'
import { Route as AppTenantIdCliPerformanceRouteImport } from './routes/_app/$tenantId/cli-performance'
import { Route as AppTenantIdCallLogsRouteImport } from './routes/_app/$tenantId/call-logs'

const TwoFactorRoute = TwoFactorRouteImport.update({
            id: '/two-factor',path: '/two-factor',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const SignOutRoute = SignOutRouteImport.update({
            id: '/sign-out',path: '/sign-out',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RecoverAccountRoute = RecoverAccountRouteImport.update({
            id: '/recover-account',path: '/recover-account',getParentRoute: () => rootRouteImport
          })
const OrganizationRoute = OrganizationRouteImport.update({
            id: '/organization',path: '/organization',getParentRoute: () => rootRouteImport
          })
const MagicLinkRoute = MagicLinkRouteImport.update({
            id: '/magic-link',path: '/magic-link',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const EmailOtpRoute = EmailOtpRouteImport.update({
            id: '/email-otp',path: '/email-otp',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const CallbackRoute = CallbackRouteImport.update({
            id: '/callback',path: '/callback',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
            id: '/accept-invitation',path: '/accept-invitation',getParentRoute: () => rootRouteImport
          })
const AdminRouteRoute = AdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AppRouteRoute = AppRouteRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AppOnboardingRoute = AppOnboardingRouteImport.update({
            id: '/app/onboarding',path: '/app/onboarding',getParentRoute: () => rootRouteImport
          })
const errors503Route = errors503RouteImport.update({
            id: '/(errors)/503',path: '/503',getParentRoute: () => rootRouteImport
          })
const errors500Route = errors500RouteImport.update({
            id: '/(errors)/500',path: '/500',getParentRoute: () => rootRouteImport
          })
const errors404Route = errors404RouteImport.update({
            id: '/(errors)/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const errors403Route = errors403RouteImport.update({
            id: '/(errors)/403',path: '/403',getParentRoute: () => rootRouteImport
          })
const errors401Route = errors401RouteImport.update({
            id: '/(errors)/401',path: '/401',getParentRoute: () => rootRouteImport
          })
const OrganizationIndexRoute = OrganizationIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OrganizationRoute
          })
const OrganizationSettingsRoute = OrganizationSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => OrganizationRoute
          })
const OrganizationSplatRoute = OrganizationSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => OrganizationRoute
          })
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AccountRoute
          })
const AccountSettingsRoute = AccountSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AccountRoute
          })
const AccountSplatRoute = AccountSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AccountRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRouteRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRouteRoute
          })
const AdminPermissionsRoute = AdminPermissionsRouteImport.update({
            id: '/permissions',path: '/permissions',getParentRoute: () => AdminRouteRoute
          })
const AdminOrganizationsRoute = AdminOrganizationsRouteImport.update({
            id: '/organizations',path: '/organizations',getParentRoute: () => AdminRouteRoute
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRouteRoute
          })
const AppTenantIdIndexRoute = AppTenantIdIndexRouteImport.update({
            id: '/$tenantId/',path: '/$tenantId/',getParentRoute: () => AppRouteRoute
          })
const AppTenantIdSettingsRoute = AppTenantIdSettingsRouteImport.update({
            id: '/$tenantId/settings',path: '/$tenantId/settings',getParentRoute: () => AppRouteRoute
          })
const AppTenantIdNumbersRoute = AppTenantIdNumbersRouteImport.update({
            id: '/$tenantId/numbers',path: '/$tenantId/numbers',getParentRoute: () => AppRouteRoute
          })
const AppTenantIdCliPerformanceRoute = AppTenantIdCliPerformanceRouteImport.update({
            id: '/$tenantId/cli-performance',path: '/$tenantId/cli-performance',getParentRoute: () => AppRouteRoute
          })
const AppTenantIdCallLogsRoute = AppTenantIdCallLogsRouteImport.update({
            id: '/$tenantId/call-logs',path: '/$tenantId/call-logs',getParentRoute: () => AppRouteRoute
          })





const AppRouteRouteChildren = {
  AppIndexRoute: AppIndexRoute,AppTenantIdCallLogsRoute: AppTenantIdCallLogsRoute,AppTenantIdCliPerformanceRoute: AppTenantIdCliPerformanceRoute,AppTenantIdNumbersRoute: AppTenantIdNumbersRoute,AppTenantIdSettingsRoute: AppTenantIdSettingsRoute,AppTenantIdIndexRoute: AppTenantIdIndexRoute
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)




const AdminRouteRouteChildren = {
  AdminOrganizationsRoute: AdminOrganizationsRoute,AdminPermissionsRoute: AdminPermissionsRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(AdminRouteRouteChildren)




const AccountRouteChildren = {
  AccountSplatRoute: AccountSplatRoute,AccountSettingsRoute: AccountSettingsRoute,AccountIndexRoute: AccountIndexRoute
}

const AccountRouteWithChildren = AccountRoute._addFileChildren(AccountRouteChildren)




const OrganizationRouteChildren = {
  OrganizationSplatRoute: OrganizationSplatRoute,OrganizationSettingsRoute: OrganizationSettingsRoute,OrganizationIndexRoute: OrganizationIndexRoute
}

const OrganizationRouteWithChildren = OrganizationRoute._addFileChildren(OrganizationRouteChildren)

const rootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,AdminRouteRoute: AdminRouteRouteWithChildren,AcceptInvitationRoute: AcceptInvitationRoute,AccountRoute: AccountRouteWithChildren,CallbackRoute: CallbackRoute,DashboardRoute: DashboardRoute,EmailOtpRoute: EmailOtpRoute,ForgotPasswordRoute: ForgotPasswordRoute,MagicLinkRoute: MagicLinkRoute,OrganizationRoute: OrganizationRouteWithChildren,RecoverAccountRoute: RecoverAccountRoute,ResetPasswordRoute: ResetPasswordRoute,SignInRoute: SignInRoute,SignOutRoute: SignOutRoute,SignUpRoute: SignUpRoute,TwoFactorRoute: TwoFactorRoute,errors401Route: errors401Route,errors403Route: errors403Route,errors404Route: errors404Route,errors500Route: errors500Route,errors503Route: errors503Route,AppOnboardingRoute: AppOnboardingRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)